// const API_URL = "http://localhost:8080";
const API_URL = "https://worklob-backend-use.onrender.com";

export default API_URL;
